// labelingValidation.js — ISO/Korean field validation helpers
// Used by DonutLabelingFieldGrid to show red borders + tooltip on invalid input.

const VIN_RE = /^[A-HJ-NPR-Z0-9]{17}$/;
const PLATE_RE = /^[0-9]{2,3}[가-힣][0-9]{4}$/;
const JUMIN_RE = /^[\d*]{6}-[\d*]{7}$/;
const YEAR_RE = /^\d{4}$/;

/**
 * validateField(name, value)
 * Returns { ok: boolean, message?: string }
 *
 * Rules:
 *   vin          — ISO 3779: 17 chars, A-H J-N P R-Z 0-9 (no I/O/Q)
 *   plate_no     — Korean vehicle plate: NN가NNNN or NNN가NNNN
 *   owner_id_no  — 주민/사업자: 6-7 digits with optional * masking
 *   year         — 4-digit year
 *   others       — always ok
 *   empty/null   — always ok (don't flag blank)
 */
export function validateField(name, value) {
  if (!value) return { ok: true };
  switch (name) {
    case "vin":
      return VIN_RE.test(value)
        ? { ok: true }
        : { ok: false, message: "VIN ISO 17자 (I/O/Q 제외) 위반" };
    case "plate_no":
      return PLATE_RE.test(value)
        ? { ok: true }
        : { ok: false, message: "한국 자동차등록번호 형식 위반" };
    case "owner_id_no":
      return JUMIN_RE.test(value)
        ? { ok: true }
        : { ok: false, message: "주민/사업자번호 13자리 위반" };
    case "year":
      return YEAR_RE.test(value)
        ? { ok: true }
        : { ok: false, message: "연도 4자리 위반" };
    default:
      return { ok: true };
  }
}
